export const KysStatus = {
    VERIFIED: 'verified',
    NEGATIVE: 'negative',
    NOT_VERIFIED: 'not_verified'
};
